export default {
  addEventStatusAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addEventStatus", payload)
      resolve()
    })
  }
}
